import { NodeShape } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Shape/NodeShape';
import { BEInterface } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEInterface';
import { PartShape } from '../../BaseShape/PartShape';
import { MDAConstant } from '../../Base/MDAConstant';
import { BaseElement } from '../../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { InterfaceAttribute } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/InterfaceAttribute';
import { InterfaceMethod } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/InterfaceMethod';
import { ValidationResult } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';
import { EnumErrorLevel } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumErrorLevel';
import { ValidationResultHelper } from '../../Base/ValidationResultHelper';
import { ValidateHelper } from '../../../../Product/IDE/Util/ValidateHelper';
import { MDShape } from '../../BaseShape/MDShape';
import { Diagram } from '../Diagram';
import { MDExtendService } from '../../../MD/MDExtendService';
import { BEComponent } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { MethodParameter } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/MethodParameter';
import { Double2D } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/Double2D';
import { EnumPersistenceStatus } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { EnumDisplayLanguage } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/EnumDisplayLanguage';
import { EnumDataType, EnumDataTypeMD } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { ShapeModel } from '../../BaseShape/ShapeModel';
import { MDValidation } from '../../../MD/MDValidation';
import { MDRepository } from '../../../MD/MDRepository';

export class JointInterfaceShape extends PartShape {
  constructor(attributes?: any, opt?: any) {
    super(attributes, opt);
    // this.id = this.curEntity.designId;
    this.set('type', 'mst.JointInterfaceShape');
    this.attr({
      '.uml-class-container': { fill: '#e0ffff', stroke: 'e0ffff' },
      '.uml-class-part-rect': { fill: '#e0ffff' },
      '.uml-type-icon': { xlinkHref: '/imgs/icons/icon_Interface.png' }
    });
    // 反序列化调用，手工创建的时候不调用
    if (attributes) {
      this.setMD(attributes?.shape, attributes?.model.element, true);
    }
  }

  public setMD(elementShape: NodeShape, element: BEInterface, isFromJSON: boolean) {
    if (element) {
      MDExtendService.setElementListSequence(element.attributes, false);
      MDExtendService.setElementListSequence(element.methods, false);
      element.methods.forEach(method => {
        MDExtendService.setElementListSequence(method.parameters, false);
      });
    }
    this.setBaseMD(elementShape, this.createModel(element, !elementShape.isExpend), isFromJSON);
  }

  public shapeType(): string {
    return MDAConstant.Type.ADD_INTERFACE;
  }

  get interface(): BEInterface {
    return this.element() as BEInterface;
  }

  doAction(action: string, designId?: string): BaseElement | null {
    let element = super.doAction(action, designId);
    switch (action) {
      // 添加属性
      case 'shape:addAttribute':
        element = this.addAttribute();
        break;
      // 添加方法
      case 'shape:addMethod':
        element = this.addMethod();
        break;
      case 'shape:deleteAttribute':
        element = this.deleteAttribute(designId);
        break;
      case 'shape:deleteMethod':
        element = this.deleteMethod(designId);
        break;
      case 'shape:deleteChild':
        element = this.deleteChild(designId);
        break;
      default:
        break;
    }
    this.refresh();
    return element;
  }

  /** 根据链接的类型，设置鼠标的样式 */
  setLinkType(linkType: string) {
    if (linkType === MDAConstant.Link.ADD_GENERALIZATION) {
      this.attr({ '.uml-class-container': { cursor: 'crosshair' }, '.uml-class-name-text': { cursor: 'crosshair' } });
    } else if (linkType === MDAConstant.Link.ADD_COMPOSITION || linkType === MDAConstant.Link.ADD_AGGREGATION || linkType === MDAConstant.Link.ADD_IMPLEMENT || linkType === MDAConstant.Link.ADD_ASSOCIATION) {
      this.attr({ '.uml-class-container': { cursor: 'not-allowed' }, '.uml-class-name-text': { cursor: 'not-allowed' } });
    } else {
      this.attr({ '.uml-class-container': { cursor: 'move' }, '.uml-class-name-text': { cursor: 'move' } });
    }
  }

  protected getDisplayTitle(element: BaseElement) {
    let title = element.displayName;
    if (element instanceof InterfaceAttribute) {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = `${element.name}:${this.getDataType(element.dataType, element.referenceType)}`;
      } else {
        title = `${element.displayName}:${this.getDataType(element.dataType, element.referenceType)}`;
      }
    } else if (element instanceof InterfaceMethod) {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = `${element.name}:${this.getDataType(element.returnDataType, element.returnReferenceType)}`;
      } else {
        title = `${element.displayName}:${this.getDataType(element.returnDataType, element.returnReferenceType)}`;
      }
    } else {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = element.name;
      } else {
        title = element.displayName;
      }
    }
    return title;
  }

  private addAttribute(): InterfaceAttribute {
    const attribute = MDRepository.createInterfaceAttribute(this.interface);
    MDExtendService.setElementListSequence(this.interface.attributes, true);
    this.model().compartments[0].push(attribute);
    return attribute;
  }

  private addMethod(): InterfaceMethod {
    const method = MDRepository.createInterfaceMethod(this.interface);
    MDExtendService.setElementListSequence(this.interface.methods, true);
    this.model().compartments[1].push(method);
    return method;
  }

  /** 删除属性行 */
  private deleteAttribute(designId: string) {
    const attribute = this.interface.attributes.find(item => item.designId === designId);
    if (attribute) {
      attribute.persistenceStatus = EnumPersistenceStatus.Delete;
      return this.deleteRow(designId);
    }
  }

  /** 删除方法行 */
  private deleteMethod(designId: string) {
    const method = this.interface.methods.find(item => item.designId === designId);
    if (method) {
      method.persistenceStatus = EnumPersistenceStatus.Delete;
      return this.deleteRow(designId);
    }
  }

  /** 删除子元素及对应的行 */
  private deleteChild(designId: string): BaseElement | null {
    let element: BaseElement = null;
    element = this.interface.attributes.find(item => item.designId === designId);
    if (!element) {
      element = this.interface.methods.find(item => item.designId === designId);
    }
    if (element) {
      // 新建状态的，需要从元数据中删除
      if (element.persistenceStatus === EnumPersistenceStatus.Create) {
        if (element instanceof InterfaceAttribute) {
          this.interface.attributes.splice(this.interface.attributes.findIndex(item => item.designId === element.designId), 1);
        } else if (element instanceof InterfaceMethod) {
          this.interface.methods.splice(this.interface.methods.findIndex(item => item.designId === element.designId), 1);
        }
      } else {
        element.persistenceStatus = EnumPersistenceStatus.Delete;
      }
      return this.deleteRow(designId);
    }
    return null;
  }

  /** 设置图形的Model */
  private createModel(bEInterface: BEInterface, isCollapse = false): ShapeModel {
    const model = new ShapeModel(bEInterface, isCollapse);
    model.addCompartment(bEInterface.attributes.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete));
    model.addCompartment(bEInterface.methods.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete));
    return model;
  }

  /**
   * 克隆图形，包括图形内部所有元素，不包括与其他图形的关系
   * @param diagram 克隆后所属的图表
   * @param elements 克隆的所有元数据都插入数组返回
   */
  public cloneShape(diagram: Diagram, elements: Array<BaseElement>): MDShape {
    const jShape = new JointInterfaceShape();

    const newShape = new NodeShape();
    newShape.copyFrom(this.shape(), false);
    MDExtendService.setCreateInfo(newShape);
    newShape.startPoint = new Double2D(this.position().x + 20, this.position().y + 20);
    newShape.diagram_ID = diagram.diagramShape.id;
    diagram.diagramShape.nodeShapes.push(newShape);

    const newElement = new BEInterface();
    newElement.copyFrom(this.interface, false);
    MDExtendService.setCreateInfo(newElement);
    elements.push(newElement);
    if (diagram.component instanceof BEComponent) {
      newElement.component_ID = diagram.component.id;
      diagram.component.interfaces.push(newElement);
    }

    this.interface.attributes.forEach(item => {
      const attribute = new InterfaceAttribute();
      attribute.copyFrom(item, false);
      MDExtendService.setCreateInfo(attribute);
      attribute.interface_ID = newElement.id;
      newElement.attributes.push(attribute);
      elements.push(attribute);
    });

    this.interface.methods.forEach(item => {
      const method = new InterfaceMethod();
      method.copyFrom(item, false);
      MDExtendService.setCreateInfo(method);
      method.interface_ID = newElement.id;
      newElement.methods.push(method);
      elements.push(method);
      item.parameters.forEach(parameter => {
        const newParameter = new MethodParameter();
        newParameter.copyFrom(parameter, false);
        MDExtendService.setCreateInfo(newParameter);
        newParameter.interfaceMethod_ID = method.id;
        method.parameters.push(newParameter);
        elements.push(newParameter);
      });
    });

    newShape.elementId = newElement.designId;
    jShape.setMD(newShape, newElement, false);
    diagram.cells.push(jShape);
    return jShape;
  }

  public addChildClone(element: BaseElement, elements: Array<BaseElement>): InterfaceAttribute | InterfaceMethod | null {
    let newElement: InterfaceAttribute | InterfaceMethod | null = null;
    if (element instanceof InterfaceAttribute) {
      newElement = new InterfaceAttribute();
      newElement.copyFrom(element, false);
      MDExtendService.setCreateInfo(newElement);
      newElement.interface_ID = this.interface.id;
      this.interface.attributes.push(newElement);
      elements.push(newElement);
    } else if (element instanceof InterfaceMethod) {
      newElement = new InterfaceMethod();
      newElement.copyFrom(element, false);
      MDExtendService.setCreateInfo(newElement);
      newElement.interface_ID = this.interface.id;
      this.interface.methods.push(newElement);
      elements.push(newElement);
      element.parameters.forEach(parameter => {
        const newParameter = new MethodParameter();
        newParameter.copyFrom(parameter, false);
        MDExtendService.setCreateInfo(newParameter);
        newParameter.interfaceMethod_ID = newElement.id;
        (newElement as InterfaceMethod).parameters.push(newParameter);
        elements.push(newParameter);
      });
    }
    return newElement;
  }

  /**
   * 校验模型
   * 1. 接口
   *    - 名称必须使用大写字母I开头
   * 2. 属性
   *    - 必须选择引用数据类型
   *    - 不能存在同名属性
   * 3. 方法
   *    - 必须选择返回值引用数据类型
   *    - 不能存在同名方法
   *    - 参数必须选择引用数据类型
   *    - 方法内不能存在同名参数
   */
  public validate(): Array<ValidationResult> {
    const errors = super.validate();
    const containerDesignId = this.interface.designId;
    MDValidation.validateBaseElement(this.interface, containerDesignId, true, errors);
    if (!this.interface.name.startsWith('I')) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `接口 [${this.interface.name}] 的名称必须使用大写字母I开头`));
    }
    this.interface.attributes.forEach(element => {
      MDValidation.validateBaseElement(element, containerDesignId, true, errors);
      if ((element.dataType === EnumDataType.Reference || element.dataType === EnumDataType.UniqueKey) && !ValidateHelper.IsNotNullOrEmpty(element.referenceType)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `接口 [${this.interface.displayName}] 的属性 [${element.displayName}] 必须选择引用数据类型`));
      }
      if (this.interface.attributes.find(item => element.designId !== item.designId && element.name === item.name)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `接口 [${this.interface.displayName}] 不能存在同名属性 [${element.name}]`));
      }
    });
    this.interface.methods.forEach((element) => {
      MDValidation.validateBaseElement(element, containerDesignId, true, errors);
      if (element.returnDataType === EnumDataType.Reference && !ValidateHelper.IsNotNullOrEmpty(element.returnReferenceType)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `接口 [${this.interface.displayName}] 的方法 [${element.displayName}] 必须选择返回值引用数据类型`));
      }
      if (this.interface.methods.find(item => element.designId !== item.designId && element.name === item.name)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `接口 [${this.interface.displayName}] 不能存在同名方法 [${element.name}]`));
      }
      element.parameters.forEach((parameter) => {
        MDValidation.validateBaseElement(parameter, containerDesignId, false, errors);
        if ((parameter.dataType === EnumDataType.Reference || parameter.dataType === EnumDataType.UniqueKey) && !ValidateHelper.IsNotNullOrEmpty(parameter.referenceType)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, parameter.designId, `接口 [${this.interface.displayName}] 方法 [${element.displayName}] 的参数 [${parameter.displayName}] 必须选择引用数据类型`));
        }
        if (element.parameters.find(item => parameter.designId !== item.designId && parameter.name === item.name)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, parameter.designId, `接口 [${this.interface.displayName}] 方法 [${element.displayName}] 不能存在同名参数 [${parameter.name}]`));
        }
      });
    });
    return errors;
  }
}
